

// Pull the friendly server message out of an apiFetch error ("API 404: {json}").
export function apiErrMsg(e: unknown, fallback: string): string {
  if (!(e instanceof Error)) return fallback;
  const brace = e.message.indexOf('{');
  if (brace >= 0) {
    try {
      const parsed = JSON.parse(e.message.slice(brace)) as { message?: string; error?: string };
      return parsed.message || parsed.error || fallback;
    } catch { /* not JSON */ }
  }
  return e.message || fallback;
}
